import { Fragment } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const LogoutModal = ({
  isOpen,
  handleOpenDrawer,
  handleLogout,
}: {
  isOpen: boolean;
  handleOpenDrawer: () => void;
  handleLogout: () => void;
}) => {
  return (
    <Fragment>
      <Dialog open={isOpen} onClose={handleOpenDrawer}>
        <DialogTitle>Log out</DialogTitle>
        <DialogContent>
          Are you sure you want to log out from this device?
        </DialogContent>
        <DialogActions>
          <div className="flex items-center gap-4">
            <button
              onClick={() => handleOpenDrawer()}
              className="font-semibold"
            >
              Cancel
            </button>
            <button className="font-semibold" onClick={() => handleLogout()}>
              Logout
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default LogoutModal;
